module.exports = __webpack_public_path__ + "static/media/cloud.4ed8f171.svg";